import React, { useMemo, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import './config/amplify';

import { store } from './store';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import ClientDashboard from './components/ClientDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import './styles/theme.css';
import { antdThemeTokens, antdComponentTokens } from './constants/theme';
import { authService } from './services/authService';
import { setLoading, setAuthenticated, setUser } from './store/slices/authSlice';
import { Spin } from 'antd';
import { setProfile } from './store/slices/userSlice';
import { userApi } from './services/userService';

// Amplify is configured in src/config/amplify.js

function AppRoutes() {
    const dispatch = useDispatch();
    const { isAuthenticated, loading } = useSelector(state => state.auth);

    useEffect(() => {
        const initializeAuth = async () => {
            try {
                dispatch(setLoading(true));
                const authStatus = await authService.checkAuthStatus();

                if (authStatus.isAuthenticated) {
                    const userDetails = await userApi.getUser();
                    dispatch(setAuthenticated(true));
                    dispatch(setUser(authStatus.user));
                    dispatch(setProfile(userDetails));
                }
            } catch (error) {
                console.error('Error initializing auth:', error);
            } finally {
                dispatch(setLoading(false));
            }
        };

        initializeAuth();
    }, [dispatch]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <Spin size="large" tip="Loading..." />
            </div>
        );
    }

    return (
        <Routes>
            <Route path="/login" element={
                isAuthenticated ? <Navigate to="/clients" replace /> : <Login />
            } />
            <Route path="/" element={<Navigate to="/clients" replace />} />
            {/* <Route path="/" element={
                <ProtectedRoute>
                    <Dashboard />
                </ProtectedRoute>
            } /> */}
            <Route path="/clients" element={
                <ProtectedRoute>
                    <ClientDashboard />
                </ProtectedRoute>
            } />
        </Routes>
    );
}

function App() {
    return (
        <Provider store={store}>
            <ConfigProvider
                theme={useMemo(() => ({
                    token: { ...antdThemeTokens },
                    components: { ...antdComponentTokens },
                }), [])}
            >
                <Router>
                    <div className="App">
                        <AppRoutes />
                    </div>
                </Router>
            </ConfigProvider>
        </Provider>
    );
}

export default App;
